export const RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM = {
  INSIGHTS: 'INSIGHTS',
  ALLOCATION: 'ALLOCATION'
};
